// extracted by mini-css-extract-plugin
export default {"imgdiv":"_1d6e590730 d24e7c0b51","img":"_72df31bdc8 _8f98dc8f96"};